import axios from 'axios';

export function authHeader() {
    const token = localStorage.getItem('token');

    if (token != null && token != '') {
        return { 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}

export const uploaderClient = axios.create({
    baseURL: process.env.VUE_APP_UPLOADER_ENDPOINT,
    headers: {
        common: {
            'Api-Version': process.env.VUE_APP_UPLOADER_VERSION,
            'X-Requested-With': 'XMLHttpRequest',
            ...authHeader(),
        }
    },
})

// Interceptor для uploaderClient - динамічно встановлює мову з localStorage
uploaderClient.interceptors.request.use(config => {
    const locale = localStorage.getItem('locale') || 'uk';
    config.headers['Api-Language'] = locale;
    return config;
});

export const client = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        common: {
            'Api-Version': process.env.VUE_APP_VERSION,
            'X-Requested-With': 'XMLHttpRequest',
            ...authHeader(),
        }
    },
});

// Interceptor для client - динамічно встановлює мову та utm_token
client.interceptors.request.use(config => {
    const vt = sessionStorage.getItem('utm_token');
    if (vt) {
        config.headers['Utm-Token'] = `${vt}`;
    }
    
    const locale = localStorage.getItem('locale') || 'uk';
    config.headers['Api-Language'] = locale;
    
    return config;
});